import ViewAudioAssets from "./pages/view-audio-assets";
import ListGraphics from "./pages/view-graphics/listGraphics";
import Dashboard from "./pages/dashboard";
import Page404 from "./pages/page-404";
import Login from "./pages/auth/Login";
import { iRoute } from "./types/routes";
import ListQuestion from "./pages/view-question";
import ListVideocard from "./pages/view-videos";
import LessonsList from "./pages/Lesson";
import LevelsList from "./pages/Level";
import QuestionsAndAnswers from "./pages/Lesson/activities";
import AddLevelForm from "./pages/Level/add.level";
import AddLessonForm from "./pages/Lesson/addLesson";
import LessonCreationForm from "./pages/Lesson/activities/LessonCreationForm";
import EditLevelForm from "./pages/Level/update.level";
import EditActivityPage from "./pages/Lesson/activities/EditActivityPage";
import DeclearAssetPage from "./pages/asset/declearAssetPage";
import GraphicsDeclarationForm from "./pages/view-graphics/add.graphics";
import ChatSeriesEditorPage from "./pages/Lesson/chat/ChatSeriesEditorPage";
import LessonActivityViewer from "./pages/Lesson/chat/LessonActivityViewer";
import AssetsUploadForm from "./pages/asset/assets.upload.form";
import OtpLogin from "./pages/auth/otp_login";
import Logout from "./pages/auth/logout";

const routes: iRoute[] = [
  { path: "/", exact: true, name: "Login", element: Login },
  { path: "/login", name: "Login", element: Login },
  { path: "/logout", name: "Logout", element: Logout },
  { path: "/otp-verification", name: "Login", element: OtpLogin },
  { path: "/dashboard", name: "Dashboard", element: Dashboard },
  { path: "/dashboard/graphics", name: "Graphics", element: ListGraphics },
  {
    path: "/dashboard/graphics/add",
    name: "New Graphic",
    element: GraphicsDeclarationForm,
  },
  {
    path: "/dashboard/assets/upload",
    name: "Upload Assets",
    element: AssetsUploadForm,
  },
  { path: "/dashboard/audios", name: "Audio", element: ViewAudioAssets },
  {
    path: "/dashboard/asset/declear/:assetType",
    name: "Declear Asset",
    element: DeclearAssetPage,
  },
  { path: "/dashboard/videos", name: "Videos", element: ListVideocard },

  {
    path: "/level/:levelId/lesson/:lessonId/activities",
    name: "Questions",
    element: ListQuestion,
  },
  { path: "/dashboard/levels", name: "Level List", element: LevelsList },
  {
    path: "/dashboard/levels/add",
    name: "New Level",
    element: AddLevelForm,
  },
  {
    path: "/dashboard/levels/edit",
    name: "Edit Level",
    element: EditLevelForm,
  },
  {
    path: "/dashboard/levels/lessons",
    name: "Level Lessons",
    element: LessonsList,
  },
  {
    path: "/dashboard/levels/lessons/add",
    name: "New Lesson",
    element: AddLessonForm,
  },
  {
    path: "/dashboard/levels/lessons/add/:lessonId",
    name: "Edit Lesson",
    element: AddLessonForm,
  },

  {
    path: "/dashboard/levels/lessons/activities",
    name: "Lesson Activies",
    element: QuestionsAndAnswers,
  },
  {
    path: "/dashboard/levels/lessons/activities/add",
    name: "New Lesson Activies",
    element: LessonCreationForm,
  },
  {
    path: "/dashboard/levels/lessons/activities/edit/:activityType/:activityId",
    name: "Edit Activity",
    element: EditActivityPage,
  },
  {
    path: "/dashboard/levels/lessons/chat/series/create",
    name: "New Chat Series",
    element: ChatSeriesEditorPage,
  },
  {
    path: "/dashboard/levels/lessons/chat/series/:serieId/edit",
    name: "Edit Chat Series",
    element: ChatSeriesEditorPage,
  },
  {
    path: "/dashboard/levels/lessons/chats/series/list",
    name: "Chat series List",
    element: LessonActivityViewer,
  },

  // {
  //   path: "/dashboard/levels/lessons/edit/:lessonId",
  //   name: "Edit Lesson",
  //   element: EditLessonForm,
  // },

  // {
  //   path: "/questions/create",
  //   name: "Create Question",
  //   element: CreateQuestion,
  // },
  // { path: "/audi", name: "Audi", element: AudioSearchBar },

  // // Don't know what they are d
  // { path: "/audios/edit/:id", name: "Audio Edit", element: AudioEdit },
  // { path: "/upload", name: "Upload", element: UploadAsset },

  { path: "dashboard/questions", name: "Questions", element: ListQuestion },

  { path: "*", name: "404", element: Page404 },
];

// UnderConstruction
export default routes;
